export const AUTH_ILLUSTRATIONS = {
  HOME_LOGIN: "/media/auth/home-login.svg",
  INSERT_PASSWORD: "/media/auth/insert-password.svg",
  CREATE_PASSWORD: "/media/auth/create-password.svg",
} as const;
